import * as React from 'react';
import { TopMenuLink, TopMenuLinkDiv } from '../../components/TopMenuLink';
import { mergeStyles } from '@cian/utils/lib/shared/style';

export interface ITopMenuLinkContainerProps {
  link?: string | null;
  name: string;
  onClickLink(): void;
  title: string;
  isOpen: boolean;
  isActive?: boolean;
}

export class TopMenuLinkContainer extends React.Component<ITopMenuLinkContainerProps> {
  public render() {
    const { link, name, onClickLink, title, isOpen, isActive } = this.props;
    const menuHoverLineView = (
      <div
        {...mergeStyles('menu-item-hover-line', isActive && !isOpen ? ' active' : '', {
          visibility: isOpen || isActive ? 'visible' : 'hidden',
        })}
      />
    );

    if (link) {
      return (
        <TopMenuLink
          name={name}
          onClickLink={onClickLink}
          title={title}
          link={link}
          menuHoverLineView={menuHoverLineView}
        />
      );
    }

    return <TopMenuLinkDiv name={name} title={title} menuHoverLineView={menuHoverLineView} />;
  }
}
